import React, { useState } from "react";
import TextField from "../../../../components/TextField";

const EstoqueMovement: React.FC = () => {
  const [name, setName] = useState("");

  return (
    <div>
      <TextField
        label="Nome do Responsável pela Adição"
        value={name}
        onChange={setName}
        placeholder="Digite aqui o nome do Responsável pela Adição"
      />
    </div>
  );
};

export default EstoqueMovement;
